import { render, staticRenderFns } from "./CTablita.vue?vue&type=template&id=1fd1c8b0"
import script from "./CTablita.vue?vue&type=script&lang=js"
export * from "./CTablita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports